import { createSelector } from 'reselect'

import { CoreRootState } from '../coreRoot.reducer'

export const getMediaData = createSelector(
  (state: CoreRootState) => state.imagesStore.mediaFiles,
  (state) => state,
)

export const getCoverImages = createSelector(
  (state: CoreRootState) => state.imagesStore.coverImages,
  (state) => state,
)

export const getProfileImages = createSelector(
  (state: CoreRootState) => state.imagesStore.profileImages,
  (state) => state,
)

export const getMediaFile = createSelector(
  (state: CoreRootState) => state.imagesStore.mediaFile,
  (state) => state,
)

export const getTemporaryMediaFile = createSelector(
  (state: CoreRootState) => state.imagesStore.temporaryMediaFile,
  (state) => state,
)

export const getSettingMediaFileUsage = createSelector(
  (state: CoreRootState) => state.imagesStore.settingMediaFileUsage,
  (state) => state,
)

export const getUploadedFileId = createSelector(
  (state: CoreRootState) => state.imagesStore.uploadedFileId,
  (state) => state,
)

export const getUploadedFile = createSelector(
  (state: CoreRootState) => state.imagesStore.uploadedFile,
  (state) => state,
)

export const getThumbnailForMediaFile = createSelector(
  (state: CoreRootState) => state.imagesStore.thumbnailForMediaFile,
  (state) => state,
)

export const getTotalMediaFilesCount = createSelector(
  (state: CoreRootState) => state.imagesStore.totalMediaFilesCount,
  (state) => state,
)
